import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/atoms/Button';
import { ApiError } from '@/services/api';
import { resetPassword } from '@/services/auth';
import styles from './Login.module.scss';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.payload && typeof err.payload === 'object' && 'code' in err.payload && err.payload.code === 'invalid_token') {
          setError('El enlace ha caducado o ya se usó. Solicita uno nuevo.');
        } else {
          setError(err.message);
        }
      } else {
        setError('Ha habido un problema. Inténtalo otra vez.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  if (!token) {
    return (
      <main className={styles.page}>
        <div className={styles.card}>
          <h1>Knooowy</h1>
          <p className={styles.subtitle}>Token inválido</p>
          <p style={{ margin: '16px 0', color: '#666' }}>El enlace está incompleto. Solicita uno nuevo desde la página de login.</p>
          <p style={{ textAlign: 'center' }}><Link to="/forgot-password" style={{ color: '#7047eb' }}>Pedir un enlace nuevo</Link></p>
        </div>
      </main>
    );
  }

  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <h1>Knooowy</h1>
        <p className={styles.subtitle}>Crea una contraseña nueva</p>

        {done ? (
          <p style={{ background: '#dcfce7', color: '#166534', padding: 12, borderRadius: 8, margin: '16px 0' }}>
            Listo. Te llevamos al login…
          </p>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form} noValidate>
            <label className={styles.field}>
              <span className={styles.label}>Nueva contraseña</span>
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={styles.input}
              />
            </label>

            <label className={styles.field}>
              <span className={styles.label}>Repetir contraseña</span>
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className={styles.input}
              />
            </label>

            {error && (
              <div role="alert" className={styles.error}>{error}</div>
            )}

            <Button type="submit" variant="primary" disabled={submitting}>
              {submitting ? 'Guardando…' : 'Guardar contraseña'}
            </Button>
          </form>
        )}
      </div>
    </main>
  );
}
